import React from 'react'

const TextBlock = ({ title, children, center }) => {
    const classNames = ["text-block"];
    if (center) classNames.push("text-center");

    return (
        <section className={classNames.join(" ")}>
            <h1 className="text-block-title">{title}</h1>
            <div className="text-block-content">
            {children}
            </div>
        </section>
    )
}

export default TextBlock


// WEBPACK FOOTER //
// ./src/components/TextBlock.js